import React, { useMemo, useState } from 'react';

import {
  Box,
  Button,
  Slide
} from '@mui/material';

import {
  DownloadOutlined
} from '@mui/icons-material';

import UserDiagnosisPanel from './components/UserDiagnosisPanel';
import SystemDiagnosisPanel from './components/SystemDiagnosisPanel';

import {
  initialSystemDiagnoses,
  initialUserDiagnoses
} from './components/templateData';

import {
  icdPageSx,
  icdPanelsSx,
  topActionSx,
  saveWrapperSx,
  saveButtonSx
} from './Styles';

const ICD10 = () => {
  const [searchValue, setSearchValue] = useState('');

  const [
    userDiagnoses,
    setUserDiagnoses
  ] = useState(initialUserDiagnoses);

  const [
    systemDiagnoses,
    setSystemDiagnoses
  ] = useState(initialSystemDiagnoses);

  const filteredUserDiagnoses = useMemo(() => {
    const value =
      searchValue.trim().toLowerCase();

    if (!value) {
      return userDiagnoses;
    }

    return userDiagnoses.filter(item => {
      return (
        item.code
          .toLowerCase()
          .includes(value) ||
        item.description
          .toLowerCase()
          .includes(value)
      );
    });
  }, [
    searchValue,
    userDiagnoses
  ]);

  const handleAddUserDiagnosis = ({
    code,
    description
  }) => {
    const trimmedCode = code.trim();
    const trimmedDescription =
      description.trim();

    if (
      !trimmedCode ||
      !trimmedDescription
    ) {
      return;
    }

    const duplicate =
      userDiagnoses.some(
        item =>
          item.code.toLowerCase() ===
          trimmedCode.toLowerCase()
      );

    if (duplicate) {
      return;
    }

    const nextId =
      userDiagnoses.length > 0
        ? Math.max(
            ...userDiagnoses.map(
              item => Number(item.id)
            )
          ) + 1
        : 1;

    setUserDiagnoses(previous => [
      {
        id: nextId,
        code: trimmedCode,
        description:
          trimmedDescription
      },
      ...previous
    ]);
  };

  const handleDeleteUserDiagnosis =
    diagnosisId => {
      setUserDiagnoses(previous =>
        previous.filter(
          item =>
            item.id !== diagnosisId
        )
      );
    };

  const handleMoveSystemDiagnosis =
    diagnosis => {
      setUserDiagnoses(previous => {
        const duplicate =
          previous.some(
            item =>
              item.code.toLowerCase() ===
              diagnosis.code.toLowerCase()
          );

        if (duplicate) {
          return previous;
        }

        return [
          {
            ...diagnosis
          },
          ...previous
        ];
      });
    };

  const handleAddSystemText = value => {
    const trimmedValue =
      value.trim();

    if (!trimmedValue) {
      return;
    }

    const nextId =
      systemDiagnoses.length > 0
        ? Math.max(
            ...systemDiagnoses.map(
              item => Number(item.id)
            )
          ) + 1
        : 1;

    setSystemDiagnoses(previous => [
      ...previous,
      {
        id: nextId,
        code: '',
        description:
          trimmedValue
      }
    ]);
  };

  const handleDeleteSystemDiagnosis =
    diagnosisId => {
      setSystemDiagnoses(previous =>
        previous.filter(
          item =>
            item.id !== diagnosisId
        )
      );
    };

  const handleSave = () => {
    const data = {
      userDiagnoses,
      systemDiagnoses
    };

    console.log(
      'ICD10 Template Save:',
      data
    );
  };

  const handleImport = () => {
    console.log('Import ICD10');
  };

  return (
    <Slide
      direction="left"
      in
      mountOnEnter
      timeout={200}
      unmountOnExit
    >
      <Box sx={icdPageSx}>
        <Box sx={topActionSx}>
          <Button
            variant="outlined"
            size="small"
            startIcon={
              <DownloadOutlined />
            }
            onClick={handleImport}
          >
            Import
          </Button>
        </Box>

        <Box sx={icdPanelsSx}>
          
          <UserDiagnosisPanel
            diagnoses={
              filteredUserDiagnoses
            }
            searchValue={
              searchValue
            }
            onSearchChange={
              setSearchValue
            }
            onAddDiagnosis={
              handleAddUserDiagnosis
            }
            onDelete={
              handleDeleteUserDiagnosis
            }
          />

          <SystemDiagnosisPanel
            diagnoses={
              systemDiagnoses
            }
            onMove={
              handleMoveSystemDiagnosis
            }
            onAddText={
              handleAddSystemText
            }
            onDelete={
              handleDeleteSystemDiagnosis
            }
          />
        </Box>

        <Box sx={saveWrapperSx}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            sx={saveButtonSx}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Slide>
  );
};

export default ICD10;